import { Component, Inject } from '@angular/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-notification-settings-page',
    templateUrl: './notification-settings-page.component.html',
    styleUrls: ['./notification-settings-page.component.scss']
})
export class NotificationSettingsPageComponent {
    constructor(@Inject('ENV') public env: Env) {}
}
